<template>
  <div class="profile-input-wrapper">
    <profile-form ref="form" endpoint="otherpreferences" @error="this.$emit('done', $event)">
      <form class="form">
        <fieldset>
          <legend class="sr-only">{{ inputTitle }}</legend>
          <span class="profile-input-label">{{ listLabel }}</span>
          <div class="flex-grid-1-col gutter-lg">
            <ul class="">
              <li v-if="hasSelectAll" class="profile-input-checkbox" style="margin-bottom: 8px">
                <label>
                  <input type="checkbox" v-model="selectAll" />
                  {{ selectAllLabel }}
                </label>
              </li>

              <li
                class="profile-input-checkbox"
                v-for="(interest, index) in interestsList"
                :key="index"
              >
                <label>
                  <input
                    type="checkbox"
                    :id="interest.value"
                    :value="interest.label"
                    :name="`interest-` + interest.value"
                    :checked="localProfile.communicationInterest.includes(interest.label)"
                    v-model="localProfile.communicationInterest"
                    data-field-type="CheckBoxSet"
                  />
                  {{ interest.label }}
                </label>
              </li>
            </ul>
          </div>
        </fieldset>
        <input value="true" type="hidden" name="isOtherPreferences" />
      </form>
    </profile-form>
  </div>
</template>

<script>
  import ProfileInputMixin from '@mixins/profile-input-mixin'

  export default {
    name: 'profile-communication-interests-input',
    mixins: [ProfileInputMixin],
    props: {
      interestsList: {
        type: Array,
        required: true
      },
      listLabel: {
        type: String
      },
      hasSelectAll: {
        type: Boolean,
        default: true
      },
      selectAllLabel: {
        type: String,
        default: 'All'
      }
    },
    data: () => ({
      localProfile: {
        communicationInterest: []
      },
      error: null
    }),
    computed: {
      userInterests() {
        return this.localProfile.communicationInterest
          .filter(
            p => this.interestsList.map(i => i.label).includes(p)
          )
      },
      selectAll: {
        get() {
          return this.interestsList ? this.userInterests.length === this.interestsList.length : false
        },
        set(value) {
          const selected = []

          if (value) {
            this.interestsList.forEach((interest) => {
              selected.push(interest.label)
            })
          }

          this.localProfile.communicationInterest = selected
        }
      }
    }
  }
</script>
